<template>
    <div>
      <span v-html="shortText"></span>
      <span  v-show="isReadMore" v-html="longText"></span>
      <span v-if="longText.length > 0">
        <strong
          v-show="!isReadMore"
          v-on:click="triggerReadMore($event, true)"
          >{{ moreStr }}</strong
        >
        <strong
          v-show="isReadMore"
          v-on:click="triggerReadMore($event, false)"
          >{{ lessStr }}</strong
        >
      </span>
    </div>
  </template>
  <script>
  export default {
    props: {
      moreStr: { type: String, default: 'read more' },
      lessStr: { type: String, default: '' },
      shortText: { type: String, default: '' },
      longText: { type: String, default: '' }
    },
    data () {
      return { isReadMore: false }
    },

    methods: {
      triggerReadMore (e, b) {
         e.preventDefault()
        this.isReadMore = b
      }
    }
  }
  </script>
